import React, { useState, useEffect } from "react";
import {
  FaUsers,
  FaFileInvoice,
  FaCog,
  FaClipboardList,
  FaImage,
  FaSignOutAlt,
} from "react-icons/fa";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import axios from "axios";
import Header from "../Components/header";
import Sidebar from "../Components/sidebar";

const API_URL = process.env.REACT_APP_API_URL;

const AdminDashboard = () => {
  const [userCount, setUserCount] = useState(0);
  const [abbonatiCount, setAbbonatiCount] = useState(0);
  const [error, setError] = useState(null);
  const [countdown, setCountdown] = useState(5);
  const [isLogged, setIsLogged] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();

  /*RECUPERA DATI UTENTI E ABBONATI */
  useEffect(() => {
    axios.defaults.withCredentials = true;

    const fetchData = async () => {
      try {
        const usersResponse = await axios.get(`${API_URL}/admin/dashboard`);
        setUserCount(usersResponse.data.total_users);
        setAbbonatiCount(usersResponse.data.total_abbonati);
      } catch (error) {
        // Se l'errore è diverso, imposta un messaggio di errore generico
        setError("Si è verificato un errore nel recupero dei dati.");
      }
    };

    fetchData();
  }, [location, navigate]);

  if (error) {
    return (
      <div className="container mx-auto mt-4">
        <div
          className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
          role="alert"
        >
          <span>{error}</span>
          {countdown > 0 && (
            <span>{` Verrai reindirizzato tra ${countdown} secondi...`}</span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className="flex min-h-screen">
        {/* Sidebar */}
        <Sidebar />

        {/* Main Content */}
        <div className="flex-1 p-6 bg-gray-100">
          <h1 className="text-3xl font-bold mb-6">Admin Dashboard</h1>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Total Users */}
            <div className="bg-white shadow rounded-lg p-6">
              <h2 className="text-xl font-semibold flex items-center mb-4">
                <FaUsers className="mr-2 text-blue-600" /> Totale utenti
              </h2>
              <p className="text-4xl">{userCount}</p>
              <button
                className="mt-4 w-full bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 transition"
                onClick={() => navigate("/admin/users")}
              >
                Visualizza Utenti
              </button>
            </div>

            {/* Revenue */}
            <div className="bg-white shadow rounded-lg p-6">
              <h2 className="text-xl font-semibold flex items-center mb-4">
                <FaFileInvoice className="mr-2 text-blue-600" /> Abbonamenti
              </h2>
              <p className="text-4xl">{abbonatiCount}</p>
              <button
                className="mt-4 w-full bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 transition"
                onClick={() => navigate("/admin/gestione-abbonamenti")}
              >
                Visualizza abbonati
              </button>
            </div>
          </div>

          {/* Recent Activity */}
          <div className="mt-6 bg-white shadow rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4">Attività Recenti</h2>
            <ul className="space-y-2">
              <li>User 1 logged in</li>
              <li>User 2 updated profile</li>
              <li>User 3 canceled subscription</li>
            </ul>
          </div>

          {/* Riviste Section */}
          <div className="mt-6 flex justify-center">
            <div className="bg-white shadow-lg rounded-lg p-8 w-full">
              {/* Il contenitore mantiene la larghezza completa */}
              <h2 className="text-2xl font-bold mb-6 flex items-center text-gray-800">
                <FaClipboardList className="mr-3 text-blue-600" /> Gestione
                Riviste
              </h2>

              <div className="flex justify-center">
                {/* Wrapper per centrare il bottone */}
                <button
                  className="w-full max-w-md bg-blue-500 text-white py-3 px-6 rounded-lg flex items-center justify-center space-x-2 
        hover:bg-blue-600 focus:ring-4 focus:ring-blue-300 transition duration-200 ease-in-out"
                >
                  <FaImage className="mr-2" />
                  <span>Gestisci riviste</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
